import React from 'react';
import MediaUploaderWrapper from 'application/components/MediaUploaderWrapper';
import { ACCEPT_AUDIO_FILETYPES } from 'application/pages/constants';
import { AdCampaignMediaTypeEnum } from '@shared/api/graphql/generated';
import VideoPromoList from '../../../AdCampaignMedia/VideoPromoList';
import VideoPromoUploader from '../../../AdCampaignMedia/VideoPromoUploader';
import ExactTimeMediaUploader from '../ExactTimeMediaUploader';
import SortableAudioUploader from '../SortableAudioUploader';
import { TEXTS } from '../texts';
import { ELEMENT_IDS } from '../consts';
import styles from '../index.module.scss';
import { MediaUploadContentProps } from './types';

const MediaUploadContent: React.FC<MediaUploadContentProps> = ({
  inputRef,
  isExactTime,
  isDraggable,
  acceptValue,
  uploadButtonText,
  uploadDescription,
  items,
  player,
  mediaUploadItems,
  isUploadDisabled,
  handleUploadClick,
  handleFilesChange,
  handleFilesSelected,
  handleRemoveClick,
  handleRetryClick,
  handleRemoveMedia,
  handleRetryMedia,
  handlePlayClick,
  handleTimeBlur,
  reorder,
  mediaType,
  timeById,
  durationById,
  onDurationChange,
  onTimeChange,
}) => (
  <div className={styles.root}>
    {!isExactTime && mediaType === AdCampaignMediaTypeEnum.Audio && isDraggable && (
      <SortableAudioUploader
        uploadButtonText={uploadButtonText}
        uploadDescription={uploadDescription}
        acceptValue={acceptValue}
        inputRef={inputRef}
        items={items}
        player={player}
        onUploadClick={handleUploadClick}
        onFilesChange={handleFilesChange}
        onPlayClick={handlePlayClick}
        onRemoveClick={handleRemoveClick}
        onRetryClick={handleRetryClick}
        onReorder={reorder}
      />
    )}

    {!isExactTime && mediaType === AdCampaignMediaTypeEnum.Audio && !isDraggable && (
      <MediaUploaderWrapper
        elementId={ELEMENT_IDS.UPLOADER}
        accept={ACCEPT_AUDIO_FILETYPES}
        items={mediaUploadItems}
        isLoading={false}
        buttonTitle={uploadButtonText}
        description={uploadDescription}
        uploaderHintText={TEXTS.INSTANT_UPLOAD_HINT}
        isUploadButtonDisabled={isUploadDisabled}
        multiple={false}
        onDrop={handleFilesSelected}
        onRemove={handleRemoveMedia}
        onRetry={handleRetryMedia}
        mediaUploaderClassname={styles.mediaUploader}
      />
    )}

    {mediaType === AdCampaignMediaTypeEnum.Video && (
      <>
        <VideoPromoUploader
          elementId={ELEMENT_IDS.UPLOADER}
          isDisabled={isUploadDisabled}
          onFilesSelected={handleFilesSelected}
        />
        {isExactTime && <p>{TEXTS.EXACT_TIME_HINT}</p>}
        <VideoPromoList
          items={items}
          isExactTime={isExactTime}
          isSortable={isDraggable}
          timeById={timeById}
          durationById={durationById}
          onTimeChange={onTimeChange}
          onDurationChange={onDurationChange}
          onRemove={handleRemoveClick}
          onRetry={handleRetryClick}
          onReorder={reorder}
        />
      </>
    )}

    {isExactTime && mediaType === AdCampaignMediaTypeEnum.Audio && (
      <ExactTimeMediaUploader
        mediaType={mediaType}
        acceptValue={acceptValue}
        uploadButtonText={uploadButtonText}
        uploadDescription={uploadDescription}
        inputRef={inputRef}
        items={items}
        timeById={timeById}
        player={player}
        onUploadClick={handleUploadClick}
        onFilesChange={handleFilesChange}
        onTimeChange={onTimeChange}
        onTimeBlur={handleTimeBlur}
        onPlayClick={handlePlayClick}
        onRemoveClick={handleRemoveClick}
        onRetryClick={handleRetryClick}
        onReorder={reorder}
      />
    )}
  </div>
);

export default MediaUploadContent;
